import { render, staticRenderFns } from "./ShowerAccessories.vue?vue&type=template&id=c1e2956a"
import script from "./ShowerAccessories.vue?vue&type=script&lang=js"
export * from "./ShowerAccessories.vue?vue&type=script&lang=js"
import style0 from "./ShowerAccessories.vue?vue&type=style&index=0&id=c1e2956a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports